import { Table, Td, Th } from '@ui'
import { UNITS, formatDuration, formatPace } from '../format.js'

// Time at distance d, interpolated between the two points either side of it.
function timeAt(points, d) {
  for (let i = 1; i < points.length; i++) {
    if (points[i].d >= d) {
      const a = points[i - 1]
      const b = points[i]
      const f = b.d > a.d ? (d - a.d) / (b.d - a.d) : 0
      return a.t + f * (b.t - a.t)
    }
  }
  return points[points.length - 1].t
}

function eleAt(points, d) {
  let last = null
  for (const p of points) {
    if (p.ele != null) last = p.ele
    if (p.d >= d) break
  }
  return last
}

// One row per whole mile/km plus the part split at the end. Times are elapsed along the
// route, so a pause lands in the split it happened in (the app doesn't store pauses).
export default function Splits({ points, unit }) {
  if (points.length < 2) return null
  const unitMeters = UNITS[unit].meters
  const total = points[points.length - 1].d
  const rows = []
  for (let start = 0; start < total - 1; start += unitMeters) {
    const end = Math.min(start + unitMeters, total)
    const seconds = timeAt(points, end) - timeAt(points, start)
    const eleStart = eleAt(points, start)
    const eleEnd = eleAt(points, end)
    rows.push({
      index: rows.length + 1,
      meters: end - start,
      ms: seconds * 1000,
      cumulativeMs: timeAt(points, end) * 1000,
      ele: eleStart != null && eleEnd != null ? eleEnd - eleStart : null,
    })
  }
  // A last part split under 50 m is just the end of the walk, not worth a row of its own.
  if (rows.length > 1 && rows[rows.length - 1].meters < 50) rows.pop()

  return (
    <Table autoWidth>
      <thead>
        <tr>
          <th>{unit === 'mi' ? 'Mile' : 'Km'}</th>
          <Th numeric>Distance</Th>
          <Th numeric>Time</Th>
          <Th numeric>Pace</Th>
          <Th numeric>Elapsed</Th>
          <Th numeric>Elevation</Th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.index}>
            <td>{r.index}</td>
            <Td numeric>{(r.meters / unitMeters).toFixed(2)}</Td>
            <Td numeric>{formatDuration(r.ms)}</Td>
            <Td numeric>{formatPace(r.ms, r.meters, unit)}</Td>
            <Td numeric>{formatDuration(r.cumulativeMs)}</Td>
            <Td numeric>{r.ele == null ? '–' : `${r.ele >= 0 ? '+' : '−'}${Math.abs(Math.round(r.ele))} m`}</Td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}
